export interface ReviewLocationSchema {
  id: string;
  name: string;
}

export interface ListReviewLocationSchema {
  data: ReviewLocationSchema[];
  total: number;
}

export enum ReviewLocationEnum {
  Canadian = 'canadian review',
  USInternational = 'us/international review',
  USInternationalAndCanadian = 'us/international and canadian review',
}

export interface ReviewLocationFlags {
  is_US_review: boolean;
  is_CAN_review: boolean;
}
